import React, { useState, useEffect } from "react";
import "../BrandschutzdokuRichtigForm/BrandschutzdokuRichtigForm.scss";
import { CiSettings } from "react-icons/ci";
import { EditBrandschutzdokuRichtigListPopup } from "../EditBrandschutzdokuRichtigListPopup/EditBrandschutzdokuRichtigListPopup";

export const BrandschutzdokuRichtigForm = (props) => {
  const [formData, setFormData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [listItems, setListItems] = useState([]);
  const [selectedListNames, setSelectedListNames] = useState({});
  const [showEditListPopup, setShowEditListPopup] = useState(false);
  const [listId, setListId] = useState("");
  const [currentFormFieldId, setCurrentFormFieldId] = useState("");

  const userToken = localStorage.getItem("userToken");
  const formId = props.formId;
  const urlParams = new URLSearchParams(window.location.search);
  const projectID = urlParams.get("project_id");

  // Fetch form and selected fields
  useEffect(() => {
    if (!formId || !projectID || !userToken) return;

    const fetchData = async () => {
      try {
        const formRes = await fetch(
          `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/form-fields-select_w.php?form_id=${formId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Token: userToken,
            },
          }
        );
        const formDataRes = await formRes.json();
        setFormData(formDataRes.data);

        const selectedRes = await fetch(
          `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/project-form-fields-select_w.php?form_id=${formId}&project_id=${projectID}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Token: userToken,
            },
          }
        );
        const selectedData = await selectedRes.json();
        const selectedFields = selectedData.data;

        const initialSelectedIds = selectedFields.map(
          (field) => field.form_field_id
        );
        setSelectedIds(initialSelectedIds);
      } catch (err) {
        console.error("Error fetching form data:", err);
      }
    };

    fetchData();
  }, [formId, projectID, userToken]);

  // Fetch list items
  useEffect(() => {
    if (!userToken) return;

    const fetchLists = async () => {
      try {
        const res = await fetch(
          "https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/lists-select_w.php",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Token: userToken,
            },
          }
        );
        const data = await res.json();
        setListItems(data.data);
      } catch (err) {
        console.error("Error fetching list items:", err);
      }
    };

    fetchLists();
  }, [userToken]);

  // Set default list selections for all fields once both formData and listItems are loaded
  useEffect(() => {
    if (formData.length > 0 && listItems.length > 0) {
      setSelectedListNames((prev) => {
        const updated = { ...prev };
        formData.forEach((field) => {
          if (field.field_type === "list" && !updated[field.form_field_id]) {
            updated[field.form_field_id] = listItems[0].list_id;
          }
        });
        return updated;
      });
    }
  }, [formData, listItems]);

  const handleCheckboxChange = (formFieldId) => {
    setSelectedIds((prev) =>
      prev.includes(formFieldId)
        ? prev.filter((id) => id !== formFieldId)
        : [...prev, formFieldId]
    );
  };

  const handleSelectChange = (e, formFieldId) => {
    const value = e.target.value;
    setSelectedListNames((prev) => ({
      ...prev,
      [formFieldId]: value,
    }));
  };

  const handleApplyButtonClick = () => {
    const requestBody = {
      project_id: projectID,
      fields_array: formData.map((field) => ({
        selected: selectedIds.includes(field.form_field_id),
        form_field_id: field.form_field_id,
      })),
    };

    fetch(
      "https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/project-form-fields-save_w.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Token: userToken,
        },
        body: JSON.stringify(requestBody),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("Saved:", data);
        props.onClose();
      })
      .catch((err) => console.error("Save error:", err));
  };

  return (
    <div className="brandschutzdoku-richtig-form">
      <div className="info">
        <div className="form-name">Form: {props.formName}</div>
        <div className="assign">
          Please assign a list to each attribute in this form
        </div>
      </div>

      <div className="table-form">
        <table>
          <thead>
            <tr>
              <th>Mandatory field</th>
              <th>Attribute Title</th>
              <th>Type</th>
              <th>Edit Assignment</th>
            </tr>
          </thead>
          <tbody>
            {formData.map((field) => (
              <tr key={field.form_field_id}>
                <td>
                  <input
                    type="checkbox"
                    onChange={() => handleCheckboxChange(field.form_field_id)}
                    checked={selectedIds.includes(field.form_field_id)}
                  />
                </td>
                <td>{field.field_title}</td>
                <td>
                  {field.field_type === "list" ? (
                    <div className="select-field">
                      <select
                        onChange={(e) =>
                          handleSelectChange(e, field.form_field_id)
                        }
                        value={selectedListNames[field.form_field_id] || ""}
                      >
                        {listItems.map((item) => (
                          <option key={item.list_id} value={item.list_id}>
                            {item.list_name}
                          </option>
                        ))}
                      </select>

                      <CiSettings
                        onClick={() => {
                          const selectedListId =
                            selectedListNames[field.form_field_id] ??
                            listItems[0]?.list_id ??
                            "";

                          setListId(selectedListId);
                          setCurrentFormFieldId(field.form_field_id);
                          setShowEditListPopup(true);
                        }}
                      />
                    </div>
                  ) : (
                    field.field_type
                  )}
                </td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>

        {showEditListPopup && (
          <EditBrandschutzdokuRichtigListPopup
            onClose={() => setShowEditListPopup(false)}
            listId={listId}
            currentFormFieldId={currentFormFieldId}
          />
        )}

        <div className="buttons">
          <button onClick={handleApplyButtonClick}>Apply</button>
          <button onClick={props.onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};
